export const terrainCacheKey = 'get-terrain-aware';